module.exports = __webpack_public_path__ + "static/media/chevron-circle-left.525fd5ef.svg";